export default function getDerivedStore(store, fields) {
  if (!Array.isArray(fields) || !store) return {};
  return fields.reduce(function (obj, name) {
    return {
      ...obj,
      [name]: store[name]
    };
  }, {});
}
